import { datadogLogs } from '@datadog/browser-logs';

let isInitialized = false;

// Initialize Datadog Logs
const initDatadog = () => {
  if (isInitialized) {
    return;
  }
  const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
  const applicationId = process.env.REACT_APP_DATADOG_APPLICATION_ID;
  const service = process.env.REACT_APP_DATADOG_SERVICE || 'videonext-web';
  const env = process.env.REACT_APP_DATADOG_ENV || process.env.NODE_ENV || 'development';
  const version = process.env.REACT_APP_DATADOG_VERSION || '1.0.0';

    // Only initialize if client token is provided
  if (clientToken) {
    datadogLogs.init({
      clientToken: clientToken,
      applicationId: applicationId,
      site: process.env.REACT_APP_DATADOG_SITE || 'datadoghq.eu',
      service: service,
      env: env,
      version: version,
      forwardErrorsToLogs: true,
      sampleRate: 100, // 100% of logs
    });

    isInitialized = true;
    console.log('Datadog logs initialized');
  } else {
    console.warn('Datadog client token not found. Logging will be disabled.');
  }
};

// Set global context that will be included in all logs
export const setGlobalContext = (key, value) => {
  if (process.env.REACT_APP_DATADOG_CLIENT_TOKEN && isInitialized) {
    datadogLogs.setGlobalContextProperty(key, value);
    console.log(`Datadog global context set: ${key} =`, value);
  }
};

// Set user context (convenience method)
export const setUserContext = (aUserId) => {
  setGlobalContext('aUserId', aUserId);
};

// Export logger functions
export const logger = {
  info: (message, context = {}) => {
    // Ensure context is an object
    const safeContext = typeof context === 'object' && context !== null ? context : { data: context };
    
    if (process.env.REACT_APP_DATADOG_CLIENT_TOKEN) {
      datadogLogs.logger.info(message, safeContext);
    } else {
      console.log('[INFO]', message, safeContext);
    }
  },
  error: (message, error = null, context = {}) => {
    // Ensure context is an object
    const safeContext = typeof context === 'object' && context !== null ? context : { data: context };
    
    if (process.env.REACT_APP_DATADOG_CLIENT_TOKEN) {
      const errorContext = error
        ? { ...safeContext, error: { message: error.message, stack: error.stack } }
        : safeContext;
      datadogLogs.logger.error(message, errorContext);
    } else {
      console.error('[ERROR]', message, error, safeContext);
    }
  },
  warn: (message, context = {}) => {
    // Ensure context is an object
    const safeContext = typeof context === 'object' && context !== null ? context : { data: context };
    
    if (process.env.REACT_APP_DATADOG_CLIENT_TOKEN) {
      datadogLogs.logger.warn(message, safeContext);
    } else {
      console.warn('[WARN]', message, safeContext);
    }
  },
  debug: (message, context = {}) => {
    // Ensure context is an object
    const safeContext = typeof context === 'object' && context !== null ? context : { data: context };
    
    if (process.env.REACT_APP_DATADOG_CLIENT_TOKEN) {
      datadogLogs.logger.debug(message, safeContext);
    } else {
      console.debug('[DEBUG]', message, safeContext);
    }
  },
};

export { initDatadog };
